"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.symbol = symbol;
function symbol() {
    // eslint-disable-next-line max-len,quotes
    return '<symbol viewbox="0 0 24 24" id=icon-file-24><path fill-rule=evenodd clip-rule=evenodd d="M21 20a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3h6.26a3 3 0 0 1 1.953.722l5.74 4.92A3 3 0 0 1 21 8.92V20ZM5 4a1 1 0 0 1 1-1h6v4a3 3 0 0 0 3 3h4v10a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4Zm13.463 4H15a1 1 0 0 1-1-1V4.174L18.463 8Z"></path></symbol>';
}
